export const mapperDataTypes=["gw-rest-object"];